export default "__VITE_ASSET__BcUKBBzH__"